import { TableCell, TableRow, Tooltip } from '@mui/material';
import { Icons, Images } from 'assets';
import styles from "pages/phNewPendingTasks/style.module.scss";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import moment from 'moment';


const FeatureBooks = () => {
    const tasksList = [
      {
        role: 1,
        status: 1,
        cover: 1,
      },
      {
        role: 2,
        status: 2,
        cover: 0,
      },
    ];
  
    return (
      <>
        {tasksList?.map((item: any, index: any, arr: any) => {
          return (
            <TableRow
            // className={classNames(index + 1 === arr.length && styles.lastCells)}
            >
              <TableCell>
                <div className={styles.nameCell}>
                  <img
                    src={Images.BookSample1}
                    alt="profile_picture"
                    className={styles.bookImg}
                  />
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <label>Harry Potter</label>
                    <label className={styles.emailLabel}>JK Rowlings</label>
                  </div>
                </div>
              </TableCell>
              <TableCell>
                <div className={styles.nameCell}>
                  <img
                    src={Images.UserPlaceholderImage}
                    alt="profile_picture"
                    className={styles.profilepic}
                  />
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <label>Ehya Publication</label>
                  </div>
                </div>
              </TableCell>
              <TableCell>{moment(new Date()).format("MMM DD, YYYY")}</TableCell>
  
              <TableCell>{item?.cover ? "Yes" : "No"}</TableCell>
              <TableCell>
                <div className={styles.actionContainer}>
                  <Tooltip arrow title="View Book">
                    <div>
                      <Icons.EyeIcon className={styles.icons} />
                    </div>
                  </Tooltip>
  
                  <Tooltip arrow title={"Approve"}>
                    <div>
                      <Icons.ApproveIcon />
                    </div>
                  </Tooltip>
                  <Tooltip arrow title={"Reject"}>
                    <div>
                      <Icons.RejectIcon />
                    </div>
                  </Tooltip>
                  <Tooltip arrow title={"Upload Cover"}>
                    <div>
                      <CloudUploadIcon sx={{ color: "#868E96" }} />
                    </div>
                  </Tooltip>
                </div>
              </TableCell>
            </TableRow>
          );
        })}
      </>
    );
  };
  

export default FeatureBooks
